import * as React from 'react';
import * as styles from './page-title.less';
import { classNames } from '../../../Shared/utils/classnames';

export interface PageTitleProps {
	name: string;
	title?: string | null;
	className?: string;
}

export const PageTitle = ({ name, title, className = '' }: PageTitleProps) => {
	return (
		<div className={classNames(styles.container, className)}>
			<p className={styles.name}>{name}</p>
			{title && <p className={styles.title}>{title}</p>}
		</div>
	);
};
